import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges
  } from '@angular/core';
  import { FormGroup } from '@angular/forms';
  import { formGroupForEachControl } from '../forms-utils';
  import { takeWhile } from 'rxjs/operators';
  
  @Component({
    selector: 'app-lab-req-base',
    template: ''
  })
  export class LabReqBaseComponent
    implements OnInit, OnChanges, AfterViewInit, OnDestroy
  {
    constructor() {}
  
    active = true;
    @Input() editable = true;
    @Input() data: any;
    @Input() templateVariant: string = '';
    @Input() customerGender: string = '';
    @Output() changed = new EventEmitter();
    form: FormGroup;
    signature: string;
  
    public get isValid(): boolean {
      return this.form?.valid;
    }
    public get value(): any {
      return this.form?.value;
    }
  
    sign(userId: string) {
      this.patchValue({
        signature: userId
      });
    }
  
    patchValue(value) {  
      this.form.patchValue(value);
    }
  
    markAllAsTouched() {
      formGroupForEachControl(this.form, control => {
        control.markAsTouched();
      });
    }
  
    ngOnChanges(changes: SimpleChanges): void {}
  
    ngOnInit() {}
  
    ngAfterViewInit(): void {
      this.form.valueChanges
        .pipe(takeWhile(() => this.active))
        .subscribe(value => {          
          this.changed.emit(this.form.value);
          this.changed.emit(value);
        });
  
      if (this.data) {
        this.patchValue(this.data);
      }
  
      if (!this.editable) {
        this.form.disable();
      }
    }
  
    ngOnDestroy(): void {
      this.active = false;
    }
  }